import { state } from '../state'
import { getIdentityStore } from '../identity-store'
import { resetPlugins } from '../plugins/install-plugins'
import { _notifyContactInfoChange } from './has-contact-info'

/**
 * Reset identity — clears userId and traits, generates new anonymousId.
 * Use for logout or user switch scenarios.
 *
 * Also dispatches `reset()` to every installed plugin so they can clear
 * plugin-local state (best-effort; errors are logged).
 */
export function reset(): void {
  const identityStore = getIdentityStore()
  identityStore.reset()

  // Update context with new anonymous identity
  if (state.context) {
    const snapshot = identityStore.getSnapshot()
    state.context.user = {
      anonymousId: snapshot.anonymousId,
      hash: snapshot.anonymousId,
      traits: {},
    }
  }

  // Notify hasContactInfo subscribers — reset typically flips the boolean
  // back to false. Listeners only fire if the boolean actually changed.
  _notifyContactInfoChange()

  // Fire-and-forget: plugin reset is best-effort cleanup
  void resetPlugins()
}
